import { bannerPurpleColor, grayColor, primaryColor, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const bannerStyle = (theme) => ({
	cardContentWrapper: {
		display: 'flex',
		flexDirection: 'column',
		[theme.breakpoints.down('sm')]: {
			flexDirection: 'column',
			justifyContent: 'flex-start',
			alignItems: 'flex-start',
		},
	},
	card: {
		margin: '30px 0',
		background: (props) => props.backgroundColor,
	},
	cardBody: {
		minHeight: '190px !important',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
	},
	buttonWrapper: {
		textAlign: 'end',
		display: 'flex',
		justifyContent: 'flex-end',
		width: '100%',
	},
	headerWrapper: {
		marginBottom: '8px',
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
	},
	badge: {
		marginLeft: '8px',
	},
	headingMBold: {
		fontFamily: theme.fontFamily.alvar.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		fontSize: theme.fontSize(20),
		lineHeight: theme.fontSize(26),
		color: (props) => props.textColor,
	},
	headingSBold: {
		fontFamily: theme.fontFamily.alvar.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.16px',
		fontSize: theme.fontSize(18),
		lineHeight: theme.fontSize(24),
		color: (props) => props.textColor,
	},
	button: {
		backgroundColor: whiteColor,
		color: bannerPurpleColor,
		border: `1px solid ${whiteColor}`,
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	customButton: {
		backgroundColor: (props) => (props.buttonBackground ? `${props.buttonBackground} !important` : whiteColor),
		color: (props) => (props.buttonTextColor ? `${props.buttonTextColor}` : bannerPurpleColor),
		'&:hover': {
			backgroundColor: 'transparent !important',
			color: (props) => (props.backgroundColor == whiteColor ? `${primaryColor[0]}` : whiteColor),
			border: (props) => `1px solid ${props.backgroundColor == whiteColor ? `${primaryColor[0]}` : whiteColor}`,
		},
	},
	customLink: {
		marginRight: '10px',
	},
	outLinedButtonLight: {
		backgroundColor: 'transparent',
		color: whiteColor,
		border: ` 1px solid ${grayColor[0]}`,
		marginLeft: '10px',
		'&:hover': {
			backgroundColor: whiteColor,
			color: bannerPurpleColor,
		},
	},
	outLinedButtonDark: {
		backgroundColor: primaryColor[5],
		color: primaryColor[0],
	},
	link: {
		fontFamily: theme.fontFamily.alvar.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: '0.16px',
		fontSize: theme.fontSize(16),
		lineHeight: theme.fontSize(22),
		color: whiteColor,
		textDecoration: 'underline',
		cursor: 'pointer',
		marginTop: '5px',
		display: 'inline-block',
		[theme.breakpoints.up('sm')]: {
			marginTop: '15px',
		},
	},
});

export default bannerStyle;
